"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "resolveShorthand", {
    enumerable: true,
    get: ()=>resolveShorthand
});
const _react = require("react");
const _constants = require("./constants");
const resolveShorthand = (value, options)=>{
    const { required =false , defaultProps  } = options || {};
    if (value === null || value === undefined && !required) {
        return undefined;
    }
    let resolvedShorthand = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof value === 'string' || typeof value === 'number' || Array.isArray(value) || /*#__PURE__*/ (0, _react.isValidElement)(value)) {
        resolvedShorthand.children = value;
    } else if (typeof value === 'object') {
        resolvedShorthand = value;
    }
    resolvedShorthand = {
        ...defaultProps,
        ...resolvedShorthand
    };
    if (typeof resolvedShorthand.children === 'function') {
        resolvedShorthand[_constants.SLOT_RENDER_FUNCTION_SYMBOL] = resolvedShorthand.children;
        resolvedShorthand.children = defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.children;
    }
    return resolvedShorthand;
}; //# sourceMappingURL=resolveShorthand.js.map

//# sourceMappingURL=resolveShorthand.js.map